var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReelPlaying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "35px",
    width: "35px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.451 25.451",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c71_play"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.562,5.523V3.257H4.83v2.265H2.562z M7.169,5.523V3.257h2.27v2.265H7.169z M11.968,5.523V3.257h2.27v2.265H11.968z  M16.576,5.523V3.257h2.268v2.265H16.576z M20.99,5.523V3.257h2.27v2.265H20.99z M2.728,18.628V6.885h20.135v11.741H2.728V18.628z  M2.562,22.257v-2.271H4.83v2.271H2.562z M7.169,22.257v-2.271h2.27v2.271H7.169z M11.968,22.257v-2.271h2.27v2.271H11.968z  M16.576,22.257v-2.271h2.268v2.271H16.576z M20.99,22.257v-2.271h2.27v2.271H20.99z M24.879,2.194H0.572 C0.257,2.194,0,2.404,0,2.667v20.118c0,0.257,0.257,0.472,0.572,0.472h24.307c0.316,0,0.572-0.215,0.572-0.472V2.667 C25.451,2.404,25.195,2.194,24.879,2.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.313,8.476c0.067-0.031,0.145-0.022,0.205,0.022l6.382,4.074c0.043,0.038,0.07,0.095,0.07,0.151 c0,0.059-0.027,0.114-0.07,0.151l-6.382,4.075c-0.037,0.027-0.078,0.042-0.122,0.042l-0.083-0.02 c-0.065-0.029-0.108-0.099-0.108-0.171v-8.15C10.205,8.576,10.248,8.509,10.313,8.476z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_260_"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReelPlaying);
export default __webpack_public_path__ + "static/media/icon-reel-playing.efcd733b46620363391cc253cc018cf1.svg";
export { ForwardRef as ReactComponent };